import { render } from "./AdminClients.vue?vue&type=template&id=34ebf432&scoped=true"
import script from "./AdminClients.vue?vue&type=script&lang=js"
export * from "./AdminClients.vue?vue&type=script&lang=js"

import "./AdminClients.vue?vue&type=style&index=0&id=34ebf432&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ebf432"]])

export default __exports__